import logo from '../assets/brand/pass24-logo.png';
import logoInvert from '../assets/brand/pass24-logo-invert.png';
import s from './ui.module.css';

/** PASS24 online logo (brand book §1.1): dark text on the light theme, white text on the dark one. */
export function BrandMark() {
  return (
    <span className={s.brandMark}>
      <img src={logo} alt="PASS24 online" className={s.brandLight} />
      <img src={logoInvert} alt="" aria-hidden="true" className={s.brandDark} />
    </span>
  );
}
